import { unFollowDoctor, followDoctor } from '@/api';

export default {
  namespaced: true,
  state: {
    specialist: {},
  },
  mutations: {
    UPDATE_INFO(state, payload) {
      state.specialist = payload;
    },
  },
  actions: {
    async handleDoctor({ commit }) {
      const { followed, doctorId } = this.specialist;
      let continueFollow = false;

      let trackId = this.trackCode;

      if (followed) {
        try {
          await this.$dialog.confirm({
            title: '取消关注',
            message: '是否取消对该医生对关注？',
          });
          await unFollowDoctor({ doctorId });
          continueFollow = false;
        } catch (err) {
          return;
        }
      } else {
        trackId = this.trackCode;
        try {
          this.ZYToast.setOnceConfig({ noToast: true });
          const res = await followDoctor({ doctorId, force: false });
          this.ZYToast.clearOnceConfig();
          if (res.success) {
            continueFollow = true;
            this.$toast.success('关注成功');
          } else if (res.isConflict) {
            await this.$dialog.confirm({
              title: '系统提示',
              confirmButtonText: '仍要关注',
              message: `为给您提供更专业、专属的服务，建议每个科室仅关注一位医生，如需关注该医生，将取消现有医生的关注关系，是否仍要关注 ${this.specialist.name} 医生`,
            });
            await followDoctor({ doctorId, force: true });
            continueFollow = true;
          } else {
            this.$toast.fail('关注失败');
            continueFollow = false;
          }
        } catch (e) {
          return;
        }
      }

      this.telescope.trackEvent({ trackId, custom: this.trackParam });

      commit('UPDATE_INFO', { followed: continueFollow });
    },
  },
};
